import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Mission = () => {
    useEffect(() => {
        document.body.style.backgroundImage = 'url("/images/toriiGate.jpg")';
        document.body.style.backgroundSize = 'cover';
        document.body.style.backgroundPosition = 'center';
        document.body.style.backgroundAttachment = 'fixed';
        document.body.style.backgroundRepeat = 'no-repeat';
    
        return () => {
            document.body.style.backgroundImage = 'none';
            document.body.style.backgroundAttachment = 'initial';
            // Reset other properties as needed
        };
    }, []);

    return (
        <div className="max-w-4xl mx-auto px-6 py-10 bg-white/80 rounded shadow text-gray-900">
            <h1 className="text-3xl font-bold mb-6 text-center">Mission</h1>

            <h2 className="text-xl font-semibold mb-4">Our Mission</h2>
            <p className="mb-6">
                At the Buddha Wisdom Organization, we dedicate ourselves to preserving the Dharma, building a physical temple and gardens, and fostering a vibrant online community. We welcome everyone—regardless of background, faith tradition, or experience level—to access teachings, meditate together, take or renew vows, and cultivate a path of compassion, peace, and understanding.
            </p>

            <h2 className="text-xl font-semibold mb-4">Preserving and Sharing the Dharma</h2>
            <p className="mb-6">
                Our primary purpose is to safeguard the wisdom and teachings of the Buddha, ensuring they remain accessible and meaningful in today’s world. Through guided meditations, Dharma talks, and the creation of extensive online resources, we strive to connect practitioners with the timeless principles of compassion, mindfulness, and loving-kindness. By doing so, we honor the ancient traditions while adapting them to the needs of modern life.
            </p>

            <h2 className="text-xl font-semibold mb-4">Building a Sanctuary for Growth</h2>
            <p className="mb-6">
                We are actively working toward establishing a physical temple and sacred garden space where practitioners can immerse themselves in meditation, study, and spiritual community. This sanctuary will serve as a haven for personal growth, healing, and refuge—a place where individuals can find stillness, learn from experienced teachers, and develop their spiritual path at their own pace.
            </p>
            <p className="mb-6">
                From beautifully landscaped grounds that encourage mindfulness in nature, to well-appointed meditation halls designed for silent retreats, every element of our future temple will be guided by a commitment to sustainability, inclusivity, and the preservation of the Earth’s natural beauty.
            </p>
            <h2 className="text-xl font-semibold mb-4">Temple Land Requirements</h2>
            <p className="mb-6">
                To realize this vision, we are seeking 40–100 acres of land (up to 50 hectares) for our temple, gardens, and community facilities.
            </p>

            <h2 className="text-xl font-semibold mb-4">Fostering a Vibrant Online Community</h2>
            <p className="mb-6">
                Recognizing that not everyone can visit a physical temple, we are equally dedicated to cultivating a robust online presence. Through virtual meditation sessions, interactive Dharma discussions, recorded talks, and accessible e-books, our digital platform invites practitioners worldwide to engage with the Dharma from wherever they are. In addition, our online temple portal allows visitors to take or renew vows, chant mantras, and immerse themselves in supportive spiritual content at their convenience.
            </p>
            <p className="mb-6">
                By embracing technology, we ensure that the Buddha’s teachings reach across borders, time zones, and circumstances—making wisdom and compassion accessible to all.
            </p>

            <h2 className="text-xl font-semibold mb-4">Inclusivity and Openness</h2>
            <p className="mb-6">
                We believe the Dharma belongs to no single group and transcends differences of race, gender, sexual orientation, religion, or nationality. Our doors, both physical and virtual, are open to anyone seeking guidance, solace, or community. We commit ourselves to creating a welcoming environment where every practitioner feels respected, heard, and valued.
            </p>

            <h2 className="text-xl font-semibold mb-4">Service and Community Engagement</h2>
            <p className="mb-6">
                Alongside teaching and spiritual activities, we aspire to support the wider community. From offering healing spaces for those in recovery and providing community workshops to forging connections with local organizations and educational institutions, our aim is to integrate Buddhist principles of service and generosity into daily life. We envision a community that nourishes its members while actively contributing to the welfare of others.
            </p>

            <h2 className="text-xl font-semibold mb-4">Looking Forward</h2>
            <p className="mb-6">
                As we continue to grow, we keep our eyes trained on the future—ever mindful of the next steps in establishing our temple grounds and expanding our online offerings. As a registered 501(c)(3) nonprofit, our long-term commitment includes a smooth transfer of responsibilities and assets to trusted successors, ensuring that the temple and teachings endure for generations to come.
            </p>

            <p className="mb-6">
                In line with that commitment, all assets will ultimately be entrusted to the <a href="https://fpmt.org" className="text-blue-600 hover:underline" target="_blank" rel="noreferrer">Foundation for the Preservation of the Mahayana Tradition (FPMT)</a> upon the passing of our students Logan Schmidt and Brandon Williams.
            </p>

            <h2 className="text-xl font-semibold mb-4">Walking the Path Together</h2>
            <p className="mb-8">
                At the Buddha Wisdom Organization, we understand that the journey toward enlightenment is not traveled alone. We invite you to join us—online or in person—as we walk this path of compassion, wisdom, and inner peace. Together, we will nurture a community where understanding grows, kindness blossoms, and the light of the Dharma guides every step.
            </p>

            <div className="text-center">
                <Link 
                    to="/discord" 
                    className="inline-block px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                >
                    Have Discord?
                </Link>
            </div>
        </div>
    );
};

export default Mission;
